const EstateProjectAPI = {
  project: {
    list: '/real_estate/projects',
    detail: '/real_estate/projects/:id',
    create: '/real_estate/projects',
    update: '/real_estate/projects/:id',
  },
  investor: {
    list: '/real_estate/projects/owners',
    create: '/real_estate/projects/owners',
  },
}

export default EstateProjectAPI
